import BookGroup from "components/BookGroup";
import { BookGroupSizeType } from "components/BookGroup/types";
import BookGroupSeriesItem from "components/BookGroup/items/BookGroupSeriesItem";
import BookSeriesHeader from "components/BookGroup/headers/BookSeriesHeader";
import { BookSerializersBookByline, PageSerializersBooksShow, SeriesSerializersBookSeriesGroup } from "types/serializers";

export default function BookSeriesGroup({
  bookSeries,
  activeBook,
  size,
}: {
  activeBook: PageSerializersBooksShow;
  bookSeries: SeriesSerializersBookSeriesGroup;
  size: BookGroupSizeType;
}) {
  const books: BookSerializersBookByline[] = bookSeries.series.bookSeries.map((bs) => {
    return {
      ...bs.book,
      featuredSeries: {
        id: bs.id,
        details: bs.details,
        position: bs.position,
        featured: bs.featured,
        series: bookSeries.series,
        collection: bs.collection,
        unreleased: bs.unreleased,
      }
    }
  });

  return (
    <BookGroup
      size={size}
      books={size === "lg" ? books.slice(0, 14) : books.slice(0, 5)}
      HeaderComponent={BookSeriesHeader}
      ItemComponent={BookGroupSeriesItem}
      context={{
        series: bookSeries.series,
        activeBook,
        activeBookSeries: bookSeries,
      }}
    />
  );
}
